import React from "react";
import { Modal, Button } from "react-bootstrap";

function ErrorModal({ show, handleClose, errorMessage }) {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton style={{ backgroundColor: "var(--bg-color)" }}>
        <Modal.Title>Message</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-danger">{errorMessage}</Modal.Body>
      <Modal.Footer style={{ backgroundColor: "var(--bg-color)" }}>
        <Button size="sm" variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorModal;
